import React from 'react';
import '../template-file-css/document-file-template.css';


export const CS_ProgressReport = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='CS_ProgressReport' className='file-pdf-document'>
            <div className='file-template'>



                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Choose the Identified Supported Employment model:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEmploymentmodel_1' name='cbEmploymentmodel_1' className='add-only' value='Traditional' /> Traditional </td>
                        <td className='w-250'><input type='checkbox' id='cbEmploymentmodel_2' name='cbEmploymentmodel_2' className='add-only' value='IPS' /> IPS </td>
                        <td className='w-250'><input type='checkbox' id='cbEmploymentmodel_3' name='cbEmploymentmodel_3' className='add-only' value='Customized Employment ' /> Customized Employment  </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Instructions:  This report must be completed in its entirety. Please give specific examples of what is being done to assist the client in becoming independent in these areas. If certain sections are not applicable, indicate accordingly. If an area was identified as not being needed on the “Supported Employment Service Agreement” please indicate that by “N/A.” </b> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Job Seeker's Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Counselor's Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtJobSeekersName' name='txtJobSeekersName' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtCounselorsName' name='txtCounselorsName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>SE Employment Specialist Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>SE Provider Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtSpecialistName' name='txtSpecialistName' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtProviderName' name='txtProviderName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Job Seeker's Employment Goal:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtEmploymentGoal' name='txtEmploymentGoal' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date range report covers:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date report submitted:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='date' id='txtDaterange' name='txtDaterange' className='add-only' /></td>
                        <td className='w-375'><input type='date' id='txtDatereport' name='txtDatereport' className='add-only' /></td>
                    </tr>
                </table>

                <h2>IDENTIFIED CONSIDERATIONS AND STRATEGIES</h2>

                <p className='w-750'>
                    <span className='eleHeader'>Medical Considerations:</span>
                    Describe any accommodations or strategies related to medical conditions being utilized during job development/employment including the responsible party. Issues may include addressing regularly scheduled medical appointments, medication side-effects, work-related restrictions, transportation to and from appointments, etc.
                    <textarea id='txtMedicalConsiderations' name='txtMedicalConsiderations' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_1' name='txtResponsiblepersons_1' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Behavioral Health Considerations:</span>
                    Describe any accommodations or strategies related to behavioral health conditions being utilized during job development/employment including the responsible party. Issues may include addressing regularly scheduled appointments, medication side-effects, work-related restrictions, transportation to and from appointments; and the strategies for addressing these considerations.
                    <i>Note: IPS must include participation in interdisciplinary meetings.</i>
                    <textarea id='txtHealthConsiderations' name='txtHealthConsiderations' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_2' name='txtResponsiblepersons_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Sensory:</span>
                    Describe how the job seekers hearing and vision needs are being addressed during job development/employment, to include the potential need for on-going communication support, orientation & mobility training at start of employment, and potential need for employer training.
                    <textarea id='txtSensory' name='txtSensory' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_3' name='txtResponsiblepersons_3' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Assistive Technology/Accommodations/On the job Supports/Learning Style:</span>
                    Describe the use of AWT, accommodation and on the job supports being utilized. Describe the strategies being used to assist the job seeker in learning their tasks, to include incorporating their preferred learning style.
                    <textarea id='txtLearningStyle' name='txtLearningStyle' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_4' name='txtResponsiblepersons_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Release of Information/Self-Advocacy:</span>
                    Describe how the disclosure of pertinent information has been addressed during job development, along with any information the job seeker does not wish to be disclosed. Also describe the job seeker's progress with/utilization of self-advocacy, along with any ongoing concerns.
                    <textarea id='txtReleaseofInformation' name='txtReleaseofInformation' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_5' name='txtResponsiblepersons_5' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Job Development:</span>
                    Describe the progress and activities being utilized to identify employers, positions and/or job tasks and how the job seeker is involved. <br />
                    <i>(IPS providers must adhere to the applicable principles and maintain fidelity to the IPS model. Customized SE providers must provide strategies specific to that model. Service delivery strategies should be those identified in the Discovery Process and Planning Meeting.)</i>
                    <textarea id='txtJobDevelopment' name='txtJobDevelopment' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_6' name='txtResponsiblepersons_6' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>On-going Supports & follow-up: </span>
                    Indicate what ongoing supports and follow up are being provided following placement to address interpersonal behaviors, workplace behaviors, adjustment services and retention.
                    <textarea id='txtfollowup' name='txtfollowup' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_7' name='txtResponsiblepersons_7' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Potential Barriers:</span>
                    Describe any new or ongoing potential barriers to employment and the related compensatory strategies ( i.e, felony background, transportation, housing, etc)
                    <textarea id='txtPotentialBarriers' name='txtPotentialBarriers' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_8' name='txtResponsiblepersons_8' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Extended Services:</span>
                    Describe how extended services following VR case closure are anticipated to be provided. Note: an extended services plan is required prior to case closure
                    <textarea id='txtExtendedServices' name='txtExtendedServices' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Responsible persons:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtResponsiblepersons_9' name='txtResponsiblepersons_9' className='add-only' /></td>
                    </tr>
                </table>





            </div>
        </form>

    )
}